import { MoonIcon, SunIcon } from "@radix-ui/react-icons";

import {
  DropdownMenu,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu/dropdown-menu";
import { Theme, useTheme } from "./theme-provider";
import { Button } from "./ui/button/button";

export function ModeToggle() {
  const { setTheme, theme } = useTheme();

  const changeThemeHandler = (theme: Theme) => {
    theme === "light" ? setTheme("dark") : setTheme("light");
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          onClick={() => changeThemeHandler(theme)}
        >
          <SunIcon className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
          <MoonIcon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
    </DropdownMenu>
  );
}
